function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M75.1197 55.34L48.1297 5.72997C43.7897 -1.57003 33.2197 -1.58003 28.8797 5.72997L1.89968 55.34C-2.53032 62.8 2.82968 72.25 11.5197 72.25H65.4997C74.1797 72.25 79.5597 62.81 75.1197 55.34ZM38.5097 63.3C36.0397 63.3 34.0297 61.29 34.0297 58.82C34.0297 56.35 36.0397 54.34 38.5097 54.34C40.9797 54.34 42.9897 56.35 42.9897 58.82C42.9897 61.29 40.9797 63.3 38.5097 63.3ZM42.9897 45.39C42.9897 47.86 40.9797 49.87 38.5097 49.87C36.0397 49.87 34.0297 47.86 34.0297 45.39V23.01C34.0297 20.54 36.0397 18.53 38.5097 18.53C40.9797 18.53 42.9897 20.54 42.9897 23.01V45.39Z",
  fill: "white"
});

var SvgAlertIcon = function SvgAlertIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 73,
    viewBox: "0 0 77 73",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlertIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert-icon.dc75c2dd.svg";
export { ForwardRef as ReactComponent };